import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  inject,
  PLATFORM_ID,
  ChangeDetectorRef,
} from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";

import { CommonModule, isPlatformServer } from "@angular/common";

import {
  TuiAlertService,
  TuiButton,
  tuiDateFormatProvider,
  TuiIcon,
  TuiLabel,
  TuiLink,
  TuiTitle,
} from "@taiga-ui/core";
import {
  TuiProgressBar,
  TuiFieldErrorPipe,
  TuiCheckbox,
  TuiFilterByInputPipe,
  TuiFiles,
} from "@taiga-ui/kit";

import {
  TuiError,
  TuiDataList,
  TuiAppearance,
  TuiRoot,
  TuiTextfield,
  TuiDropdown, TuiNumberFormat
} from "@taiga-ui/core";
import {
  TuiDataListWrapper,
  TuiRadio,
  TuiAvatar,
  TuiBadge,
  TuiItemsWithMore,
  TuiProgress,
  TuiBadgedContent,
  TuiTabs,
  TuiInputNumber,
} from "@taiga-ui/kit";

import {
  TuiInputDateModule,
  TuiInputModule,
  TuiInputPhoneModule,
  TuiInputSliderModule,
  TuiInputTimeModule,
  TuiSelectModule,
  TuiTextfieldControllerModule,
  TuiTextareaModule,
  TuiInputTagModule,
  TuiComboBoxModule,
  TuiMultiSelectModule,
  TuiInputDateTimeModule,
  TuiInputNumberModule,
} from "@taiga-ui/legacy";
import { DatePipe } from "@angular/common";
// import { v4 as uuidv4 } from 'uuid';
import { NgxSpinnerService } from 'ngx-spinner';
import { TUI_IS_E2E, TuiDay } from "@taiga-ui/cdk";
import { AsyncPipe } from "@angular/common";
import { of, timer, takeWhile, share, repeat, map, timeout, catchError } from "rxjs";
import { NG_EVENT_PLUGINS } from "@taiga-ui/event-plugins";
import { Router } from "@angular/router";
import { Meta, Title } from "@angular/platform-browser";
import { ProgramService } from "../../../services/program.service";
import { environment } from "../../../../environments/environment";
import { ClowderConfig, ClowderfrontUrl } from '../../../storan-constant';
import { SignupuserService } from "../../../services/signupuser.service";
import { ClowderService } from "../../../services/clowder.service";
import { AuthService } from "../../../services/auth.service";

@Component({
  selector: 'app-application-check-in',
  standalone: true,
  imports: [ReactiveFormsModule,
    CommonModule,
    AsyncPipe,
    TuiProgressBar,
    TuiButton,
    TuiDropdown,
    TuiLabel,
    TuiFieldErrorPipe,
    TuiError,
    TuiDataList,
    TuiAppearance,
    TuiRadio,
    TuiInputDateModule,
    TuiTextfield,
    TuiNumberFormat,
    TuiTextfieldControllerModule,
    TuiInputModule,
    TuiInputNumber,
    TuiInputPhoneModule,
    TuiInputTimeModule,
    TuiSelectModule,
    TuiTextareaModule,
    TuiCheckbox,
    TuiAvatar,
    TuiInputTagModule,
    TuiIcon,
    TuiProgress,
    TuiFilterByInputPipe,
    TuiFiles,
    TuiComboBoxModule,
    TuiMultiSelectModule,
    TuiBadgedContent,
    TuiDataListWrapper,
    TuiInputNumberModule,
    TuiInputSliderModule,
    TuiTextfieldControllerModule,
    TuiItemsWithMore,
    TuiTabs,
    FormsModule,
    TuiTitle,
    TuiInputDateTimeModule,
    TuiLink,
    TuiRoot],
  templateUrl: './application-check-in.component.html',
  styleUrl: './/application-check-in.component.css',
  // changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [NG_EVENT_PLUGINS, DatePipe, tuiDateFormatProvider({ mode: 'MDY', separator: '/' })],
})
export class ApplicationCheckinComponent {
  email: string = "campaigns.support@syngenta.com";
  selectedOption: string = "";
  currentSurveyStep: number = 2;
  currentSurveyInnerStep: number = 1;
  currentSatisfactionStep: number = 2;
  currentStep: number = 2;
  firstPage: number = 1;
  current_upload_inner_step: number = 2;
  currentSeasonSurveyStep: number = 2;
  private readonly alerts = inject(TuiAlertService);
  tankMixProducts = [
    "No tank mix partners",
    "AAtrex® brands",
    "Princep® brands",
    "Gramoxone® SL 3.0",
    "Sharpen®",
    "Warrior II with Zeon Technology®",
    "Besiege®",
    "Liberty® in LibertyLink® corn",
    "Dicamba",
    "Glyphosate in glyphosate-tolerant corn",
    "Others"
  ];

  mostChallengingWeeds = [
    "Palmer amaranth",
    "Waterhemp",
    "Giant ragweed",
    "Morningglory",
    "Russian thistle",
    "Cocklebur",
    "Barnyardgrass",
    "Foxtail species",
    "Others"
  ];

  cornHerbicideList = [
    "Acuron®",
    "Resicore®",
    "TriVolt®",
    "Acuron® GT",
    "Lexar® EZ",
    "Bicep II Magnum®",
    "Others"
  ];
  otherRateEnable: boolean = false;
  tankMixOtherEnable: boolean = false;
  weedsOtherEnable: boolean = false;
  tankMix: any[] = [];
  heribicideOtherEnable: boolean = false;
  heribicideArr: any[] = [];
  emailAddress: any;
  weeds: any[] = [];
  growerid: any;
  growerDetails: any = [];
  trialId: any;
  dataSetId: any;
  protected stateList = ["State 1", "State 2", "State 3"];
  uploadImageId: any;
  noImageAssets: any;
  applicationLockSatus: any;
  devDefaultDataset = ClowderConfig.devDefaultDataset;
  devDefaultDatasetReleaseForm = ClowderConfig.devDefaultDatasetReleaseForm;
  cleanRowPhotosStatus: any;
  disableTankOthers: boolean = false;
  commentsLength = 0;
  protected surveyForm = new FormGroup({
    applyDate: new FormControl(null, Validators.required),
    countCornAcres: new FormControl("", Validators.required),
    selectedOption: new FormControl(""),
    selectedStaisfactionScaleOption: new FormControl("", Validators.required),
    storenOtherRate: new FormControl(""),
    storenAppRate: new FormControl("", Validators.required),
    storenCornAcresTreated: new FormControl("", Validators.required),
    tankMixOptions: new FormArray(
      this.tankMixProducts.map(() => new FormControl(false))
    ),
    storenOtherApplication: new FormControl(""),
    mostChallengingWeedsOptions: new FormArray(
      this.mostChallengingWeeds.map(() => new FormControl(false))
    ),
    storenOtherMostChallenging: new FormControl(""),
    cornHerbicideListOptions: new FormArray(
      this.cornHerbicideList.map(() => new FormControl(false))
    ),
    storenOtherCornHerbicideList: new FormControl(""),
    // experienceWithStoren: new FormControl("", Validators.required),
    // improveStorenCorn: new FormControl("", Validators.required),
    storenApplicationExperience: new FormControl("", Validators.maxLength(1000)),
  });
  endOfSeasonSurveyStatus: any;
  satisfactionSurveyStatus: any;
  maxDate:any;

  get tankMixOptions(): FormArray<FormControl<boolean>> {
    return this.surveyForm.get("tankMixOptions") as FormArray<
      FormControl<boolean>
    >;
  }

  get mostChallengingWeedsOptions(): FormArray<FormControl<boolean>> {
    return this.surveyForm.get("mostChallengingWeedsOptions") as FormArray<
      FormControl<boolean>
    >;
  }

  get cornHerbicideListOptions(): FormArray<FormControl<boolean>> {
    return this.surveyForm.get("cornHerbicideListOptions") as FormArray<
      FormControl<boolean>
    >;
  }
  constructor(private router: Router, private authService: AuthService, private meta: Meta, private cdr: ChangeDetectorRef, private datepipe: DatePipe, private _clowderService: ClowderService, private spinner: NgxSpinnerService, private title: Title, private signUpservice: SignupuserService, private programService: ProgramService) {
    this.title.setTitle("Storen Application Check In");
    this.meta.updateTag({ name: 'description', content: '' })
  }
  // ngAfterViewInit() {
  //   this.cdr.detectChanges();
  //   setTimeout(() => {
  //     document.querySelector('#applicationCheckin')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  //   }, 600);
  // }
  characValidation(value: any): boolean {
    if (value.length >= 1000) {
      return false;
    }
    return true;
  }
  charSubstring(value:any){
    if(value &&value.length>1000){
       value = value.substring(0,1000)
       this.surveyForm.get('storenApplicationExperience')?.setValue(value);      
    }
  }
  ngOnInit(): void {
    this.authService.checkAuthAndRedirect();
    this.emailAddress = localStorage.getItem("email");
    this.surveyForm.get("selectedOption")?.valueChanges.subscribe((value) => {
      this.selectedOption = value ?? "";
    });
    this.getGrowerDetails();
    this.applicationLockSatus = sessionStorage.getItem('applicationLockSatus') ? sessionStorage.getItem('applicationLockSatus') : "";
    if (this.applicationLockSatus === 'COMPLETED' || this.applicationLockSatus === 'LOCK' || this.applicationLockSatus === 'GETSTARTEDDISABLE' || !this.applicationLockSatus) {
     this.router.navigate(['/program']);
    }

    this.cdr.detectChanges();
    let dataSets = JSON.stringify(environment.ClowderConfig.datasets.find(item => Object.keys(item).includes('Corn-field')));
    this.dataSetId = JSON.parse(dataSets)['Corn-field'];
    this.maxDate = TuiDay.currentLocal();
    // const growDt = localStorage.getItem("growerDetails");
    // const parsedArray = growDt ? JSON.parse(growDt) : [];
    // this.growerDetails = parsedArray;
    // this.growerid = parsedArray?parsedArray[0].GROWER_ID:"";
    // this.trialId = parsedArray[0].trail_id == null ? this.generateTrialId(this.growerDetails[0]):parsedArray[0].trail_id;

    this.surveyForm.get('storenApplicationExperience')?.valueChanges.subscribe((value) => {
      this.commentsLength = value?.length ?? 0;
    })

  }
  convertToTuiDay(date: string | Date): TuiDay {
    const jsDate = new Date(date);
    return new TuiDay(jsDate.getFullYear(), jsDate.getMonth(), jsDate.getDate());
  }
  getGrowerDetails() {
    this.programService.getgrowerdetailsbyEmailId(this.emailAddress).subscribe((res: any) => {
      this.growerDetails = JSON.parse(res);
      //localStorage.setItem("growerDetails", JSON.stringify(this.growerDetails));
      //this.programService.setGrowerDetails(this.growerDetails);
      if (this.growerDetails.length > 0) {
        this.growerid = this.growerDetails[0].GROWER_ID;
        this.trialId = this.growerDetails[0].trail_id == null ? this.generateTrialId(this.growerDetails[0]) : this.growerDetails[0].trail_id;
      }
    })
  }

  changeApplicationRate(event: any) {
    //Enable Other Textbox
    if (event.target.value === 'Other') {
      this.otherRateEnable = true;
      this.surveyForm.get('storenOtherRate')?.setValidators(Validators.required);
    } else {
      this.otherRateEnable = false;
      this.surveyForm.get('storenOtherRate')?.clearValidators();
    }

    this.surveyForm.get('storenOtherRate')?.updateValueAndValidity();
  }


  changeTankMix(event: any, option: any, index: any) {
    //Enable Other Textbox

    /*   if (option === 'Others' && event.target.checked === true) {
         this.tankMixOtherEnable = true;
         this.surveyForm.get('storenOtherApplication')?.setValidators(Validators.required);
         const i = this.tankMix.indexOf(option);
         if (i > -1) { 
           this.tankMix.splice(i, 1);
         } else {
           this.tankMix.push(option);
         }
       } else if (option === 'Others' && event.target.checked === false) {
         this.tankMixOtherEnable = false;
         this.surveyForm.get('storenOtherApplication')?.clearValidators();
         this.surveyForm.get('storenOtherApplication')?.setValue('');  // Unchecked clear Others field
         const i = this.tankMix.indexOf("Others");
         if (i > -1) { 
           this.tankMix.splice(i, 1);
         }
       } else{
      
       if (event.target.checked === true && option !== 'Others') {
         const i = this.tankMix.indexOf(option);
         if (i > -1) { // Already exist remove it
           this.tankMix.splice(i, 1);
         } else { // Not in array adding
           this.tankMix.push(option);
         }
       } else {
         const i = this.tankMix.indexOf(option);
         if (i > -1) {
           this.tankMix.splice(i, 1);
         } 
       }
     }
     this.surveyForm.get('storenOtherApplication')?.updateValueAndValidity();*/
    if (option === "No tank mix partners" && event.target.checked === true) {

      const notankmix = this.tankMixOptions.at(0);
      this.tankMixOptions.controls.forEach((ctrl, i) => {
        if (i !== 0) {
          ctrl.setValue(false);
          ctrl.disable();
          this.tankMix = [];
          this.tankMixOtherEnable = false;
          this.surveyForm.get('storenOtherApplication')?.clearValidators();
        }
      })
      this.surveyForm.get('storenOtherApplication')?.updateValueAndValidity();
    } else if (option === "No tank mix partners" && event.target.checked === false) {
      this.tankMixOptions.controls.forEach((ctrl, i) => {
        if (i !== 0) {
          ctrl.enable();
        }
      })
    }
    if (option === 'Others' && event.target.checked === true) {
      this.tankMixOtherEnable = true;
      this.surveyForm.get('storenOtherApplication')?.setValidators(Validators.required);
    } else if (option === 'Others' && event.target.checked === false) {
      this.tankMixOtherEnable = false;
      // this.surveyForm.get('storenOtherApplication')?.setValue('');  // Unchecked clear Others field
      this.surveyForm.get('storenOtherApplication')?.clearValidators();
    }
    this.surveyForm.get('storenOtherApplication')?.updateValueAndValidity();

    if (event.target.checked === true) {
      this.tankMix.push(option);
    } else {
      if (this.tankMix.length > 0) {
        const i = this.tankMix.indexOf(option);
        if (i !== -1) {
          this.tankMix.splice(i, 1);
        }
      }
    }


  }
  minSelectedCheckboxes(min: number) {
    return (formArray: AbstractControl) => {
      const selectedCount = (formArray as FormArray).controls.map(control => control.value)
        .filter(value => value).length;
      return selectedCount >= min ? null : { requires: true };
    }
  }
  isAnyTankSelected() {
    return this.tankMixOptions.controls.some(control => control.value);
  }
  isAnyHerbicideSelected() {
    return this.cornHerbicideListOptions.controls.some(control => control.value);
  }
  isAnyWeedsSelected() {
    return this.mostChallengingWeedsOptions.controls.some(control => control.value);
  }
  changeHeribicide(event: any, option: any, index: any) {
    if (option === 'Others' && event.target.checked === true) {
      this.heribicideOtherEnable = true;
      this.surveyForm.get('storenOtherCornHerbicideList')?.setValidators(Validators.required);
    } else if (option === 'Others' && event.target.checked === false) {
      this.heribicideOtherEnable = false;
      // this.surveyForm.get('storenOtherCornHerbicideList')?.setValue('');  // Unchecked clear Others field
      this.surveyForm.get('storenOtherCornHerbicideList')?.clearValidators();
    }
    this.surveyForm.get('storenOtherCornHerbicideList')?.updateValueAndValidity();
    if (event.target.checked === true) {
      this.heribicideArr.push(option);
    } else {
      if (this.heribicideArr.length > 0) {
        const i = this.heribicideArr.indexOf(option);
        if (i !== -1) {
          this.heribicideArr.splice(i, 1);
        }
      }
    }
  
  }
  changeWeeds(event: any, option: any, index: any) {
    if (option === 'Others' && event.target.checked === true) {
      this.weedsOtherEnable = true;
      this.surveyForm.get('storenOtherMostChallenging')?.setValidators(Validators.required);
    } else if (option === 'Others' && event.target.checked === false) {
      this.weedsOtherEnable = false;
      // this.surveyForm.get('storenOtherMostChallenging')?.setValue(''); 
      this.surveyForm.get('storenOtherMostChallenging')?.clearValidators();
    }
    this.surveyForm.get('storenOtherMostChallenging')?.updateValueAndValidity();
    if (event.target.checked === true) {
      this.weeds.push(option);
    } else {
      if (this.weeds.length > 0) {
        const i = this.weeds.indexOf(option);
        if (i !== -1) {
          this.weeds.splice(i, 1);
        }
      }
    }
  }
  getTankMixOtherProduct(event: any) {
    let valueStore = event.target.value.split('').reverse().join('');
    this.surveyForm.patchValue({ 'storenOtherApplication': valueStore });
  }
  generateTrialId(growerDetails: any) {
    const CU = growerDetails['CU_Description'];
    const growerLastName = growerDetails['USER_LAST_NAME'];
    const randomSixDigitNumber = Math.floor(100000 + Math.random() * 900000);
    const year = new Date().getFullYear();
    return `${CU}_${growerLastName}_${randomSixDigitNumber}_${year}`;
  };
  async submit() {
    this.spinner.show();
    //this.currentSurveyInnerStep = 2;
    this.firstPage = 0;

    if (this.surveyForm.valid) {
     
      if (this.growerDetails[0].trail_id == null || this.growerDetails[0].trail_id == "") {
        const trialdetails =
        {
          "TrialId": this.trialId,
          "TrialType": "SSP",
          "GrowerId": this.growerid,
          "Crop": "Corn (field)",
          "NoOfTreatments": 1,
          "treatments": [""],
          "TreatmentName": [""],
          "NoOfReplication": 1,
          "GeoLatitude": "0.000000",
          "GeoLongitude": "0.000000",
          "AddressLine1": this.growerDetails ? this.growerDetails[0]['USER_ADDRESS1'] : "",
          "AddressLine2": this.growerDetails ? this.growerDetails[0]['USER_ADDRESS2'] : "",
          "City": this.growerDetails ? this.growerDetails[0]['USER_CITY'] : "",
          "State": this.growerDetails ? this.growerDetails[0]['USER_STATE'] : "",
          "ZipCode": this.growerDetails ? this.growerDetails[0]['USER_POSTAL_CODE'] : "",
          "TrialTreatments": "",
          "FieldDescription": "",
          "UpdatedBy": this.emailAddress,
          "TreatmentName1": ""
        };
        await this.programService.trialRegistration(trialdetails).subscribe((response) => {
          if (response > 0) {
          } else {
            this.spinner.hide();
            this.alerts.open('<strong>Something went wrong</strong>', { label: 'Error!', appearance: 'negative', autoClose: 1000 }).subscribe();
          }
        });
      }


      await this.uploadDefaultNoImage();
      // let saveApplCheckInObj = {
      //   "GrowerId": this.growerid,
      //   "TrailId": this.trialId,
      //   "ProgramScheduleId": 1,
      //   "Programstatus": "Completed"
      // }
      // this.programService.insertprogramdetails(saveApplCheckInObj).subscribe(async () => {
      //   //await this.uploadDefaultNoImage();
      //   // this.currentSurveyInnerStep = 2;
      //   // this.spinner.hide();
      // }, (error) => {
      //   this.spinner.hide();
      //   console.error('Error saving API :', error);
      // });


    } else {
      this.spinner.hide();
      // this.alerts.open('<strong>Something went wrong</strong>', { label: 'Error!', appearance: 'negative', autoClose: 1000 }).subscribe();
      this.alerts.open(`<strong>Please enter all mandatory fields in the Application CheckIn</strong>`,
        { label: 'Error!', appearance: 'negative', autoClose: 5000 }).subscribe();
    }
  }

  private async uploadDefaultNoImage(): Promise<void> {
    try {
      this.spinner.show();
      // const id = crypto.randomUUID();
      // Create and upload new no-image asset
      const response1 = await fetch('No-image.png');
      const blob = await response1.blob();
      const uniquenumber = Date.now();
      //  const fileName = `No-Image_${uuidv4().substr(0, 6)}.png`;
      const fileName = `No-Image_${uniquenumber}.png`;
      const file = new File([blob], fileName, { type: blob.type });

      const formDatas = new FormData();
      formDatas.append('type', 'file');
      formDatas.append('path', `/${fileName}`);
      formDatas.append('file', file, fileName);
      this.noImageAssets = ClowderfrontUrl + 'Corn-field/' + fileName;

      new Promise((resolve, reject) => {
        this._clowderService.uploadImage(formDatas, this.dataSetId)
          .pipe(
            timeout(90000),
            catchError(error => {
              this.handleError(error, 'Error uploading no-image asset');
              this.errorCaptureDB(error,"Error Uploading no-image asset");
              reject(error);
              return throwError(() => error);
            })
          )
          .subscribe({
            next: (res) => {
              if (res['id'] !== '') {

                // this.spinnerContent = "Uploading Metadata";
                // this.spinnerPercentage = 60;
                this.uploadImageId = res['id'];
                resolve(this.uploadImageMetadata(res['id']));
              }
            },
            error: (error) => reject(error)
          });
      });
      //this.current_step = 2;
      this.cdr.detectChanges();

    } catch (error) {
      console.error('Error uploading no-image asset:', error);
      throw error;
    }
  }

  errorCaptureDB(error:any,errorMsgs:any){
    let newVar = this.stripHtmlTags(error.error);
    let textLog = 'GrowerId:'+this.growerid+','+'Email:'+this.emailAddress+','+"Program:application-checkin,Message="+error.message+"Error:"+newVar;  
    this.programService.errorDetailsLog(textLog, errorMsgs).subscribe(res => {
    }, (error) => {
      console.error('Error saving dataloop API :', error);
    });

  }
  private stripHtmlTags(html: string): string {
    if (typeof html !== 'string') return '';
    return html.replace(/<[^>]*>/g, '').replace(/\n/g, ' ').trim();
  }
  updateStatusDB(){
    let saveApplCheckInObj = {
        "GrowerId": this.growerid,
        "TrailId": this.trialId,
        "ProgramScheduleId": 1,
        "Programstatus": "Completed"
      }
      this.programService.insertprogramdetails(saveApplCheckInObj).subscribe(async () => {
        //await this.uploadDefaultNoImage();
        //this.currentSurveyInnerStep = 2;
        // this.spinner.hide();
      }, (error) => {
        this.spinner.hide();
        console.error('Error saving API :', error);
      });
  }

  async uploadImageMetadata(fileId: any) {
    this.spinner.show();
    const SubmittedOn = this.datepipe.transform(new Date(), 'MM/dd/yyyy HH:mm:ss')
    // const SubmittedOn = new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
    const applyDateOn = this.surveyForm?.value?.applyDate
      ? this.convertToDate(this.surveyForm.value.applyDate)
      : new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });

    //Storen App Rate
    let appRate: any;
    if (this.surveyForm.value.storenAppRate === 'Other') {
      appRate = this.surveyForm.value.storenOtherRate;
    } else {
      appRate = this.surveyForm.value.storenAppRate;
    }

    //Tank Mix
    let storenTankOther = this.tankMix.indexOf('Others');
    if (storenTankOther !== -1) {
      this.tankMix.splice(storenTankOther, 1);
      this.tankMix.push(this.surveyForm?.value.storenOtherApplication);
    }

    //Weeds
    let weedsOthers = this.weeds.indexOf('Others');
    if (weedsOthers !== -1) {
      this.weeds.splice(weedsOthers, 1);
      this.weeds.push(this.surveyForm?.value.storenOtherMostChallenging);
    }

    //Herbicide

    let heribicide = this.heribicideArr.indexOf('Others');
    if (heribicide !== -1) {
      this.heribicideArr.splice(heribicide, 1);
      this.heribicideArr.push(this.surveyForm?.value.storenOtherCornHerbicideList);
    }
    let noImageFilename = this.noImageAssets.split('/')[4];
    // let rateArr = [
    //   { 'ratingnum': '1', 'ratingText': 'Very Difficult' },
    //   { 'ratingnum': '2', 'ratingText': 'Somewhat Difficult' },
    //   { 'ratingnum': '3', 'ratingText': 'Neutral' },
    //   { 'ratingnum': '4', 'ratingText': 'Somewhat Easy' },
    //   { 'ratingnum': '5', 'ratingText': 'Very Easy' },
    // ];
    // let ratingConfirm = rateArr.filter(p => p.ratingnum === this.surveyForm?.value?.selectedStaisfactionScaleOption)[0]
    // ['ratingnum'] + '-' + rateArr.filter(p => p.ratingnum === this.surveyForm?.value?.selectedStaisfactionScaleOption)[0]['ratingText']

    let saveApplicationCheckInObj1 = {
      "MS-Trial Type": "SSP",
      "MS-Trial ID": this.trialId,
      "MS-Asset Type": "No-Image",
      "MS-Asset-url": this.noImageAssets,
      "MS-SubmittedOn": SubmittedOn,
      "MS-Asset File Name": noImageFilename,
      "MS-CU Role": this.growerDetails[0]['CU_Description'],
      "MS-Crop": "Corn (field)",
      "MS-Product Type": "Herbicide",
      "MS-Product": "Storen",
      "MS-Submitter Email": this.emailAddress,
      "MS-Program Status": "Application Check In",
      "MS-Application Check In": {
        "MS-Applied Storen": "Yes",
        "MS-Applied On": applyDateOn,
        "MS-Total Corn Acres Planted": this.surveyForm?.value?.countCornAcres,
        "MS-Acres Treated with Storen": this.surveyForm?.value?.storenCornAcresTreated,
        "MS-Application Rate": appRate,
        "MS-Tank Mix Products": this.tankMix,
        "MS-Challenging Weeds": this.weeds,
        "MS-Corn Herbicide used last season": this.heribicideArr,
        "MS-Rate": this.surveyForm?.value?.selectedStaisfactionScaleOption,
        "MS-Comments": this.surveyForm?.value?.storenApplicationExperience !== "" ? this.surveyForm?.value?.storenApplicationExperience : "",
      },
      "MS-SU Approval Status": "Pending",
      "MS-SU Approved or Rejected Date": "",
      "MS-SU Approved or Rejected by": "",
      "MS-SU Comments": "",
      "MS-Legal Approval Status": "Pending",
      "MS-Legal Approved or Rejected Date": "",
      "MS-Legal Comments": "",
      "MS-Legal Approved or Rejected by": ""
    }


    return this._clowderService.uploadImageMetadata(fileId, saveApplicationCheckInObj1, this.emailAddress)
      .pipe(
        catchError(error => {
          this.handleError(error, `Error uploading metadata for ${this.noImageAssets}`);
          this.errorCaptureDB(error,`Error uploading metadata for ${this.noImageAssets}`);
          // this.spinnerPercentage = 0;
          // this.spinnerContent = "Loading";
          this.spinner.hide();
          return throwError(() => error);
        })
      )
      .subscribe({
        next: (res) => {
          if (res) {
            // window.scrollTo({ top: 0, behavior: 'smooth' });
            this.updateStatusDB();
            sessionStorage.setItem("applicationLockSatus", "COMPLETED");
            this.applicationLockSatus = sessionStorage.getItem("applicationLockSatus");
            this.satisfactionSurveyStatus = sessionStorage.getItem("satisfactionSurveyStatus");
            this.cleanRowPhotosStatus = sessionStorage.getItem("cleanRowPhotosStatus");
            this.endOfSeasonSurveyStatus = sessionStorage.getItem("endOfSeasonSurveyStatus");
            if (this.endOfSeasonSurveyStatus == 'COMPLETED' && this.cleanRowPhotosStatus == 'COMPLETED' && this.satisfactionSurveyStatus == 'COMPLETED' && this.applicationLockSatus == 'COMPLETED') {
              this.router.navigate(['/program-complete']).then(()=>{
                window.scrollTo({top:0,behavior:'smooth'});
              });
              // this.currentStep = 6;
            } else {
              setTimeout(() => {
                document.querySelector('#applicationThanks')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }, 600)
              this.currentSurveyInnerStep = 2;
            }
            this.spinner.hide();
          }

        },
        error: (error) => {
          // this.spinnerPercentage = 0;
          // this.spinnerContent = "Loading";
          
          this.spinner.hide();
          this.errorCaptureDB(error,`Error uploading metadata for ${this.noImageAssets}`);
          this.handleError(error, `Error uploading metadata for ${this.noImageAssets}`);
        }
      });
  }

  private handleError(error: any, customMessage: string = 'An error occurred'): void {
    console.error('API Error:', error);
    this.spinner.hide();
    this.alerts.open(customMessage, {
      label: 'Error!',
      appearance: 'error',
      autoClose: 5000
    }).subscribe();
  }
  convertToDate(tuiDay: TuiDay): string {
    if (tuiDay === null || tuiDay === undefined) {
      return '';
    }
    const date = new Date(tuiDay.year, tuiDay.month, tuiDay.day);
    return date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
  }
  returnDashboard() {
    this.currentSurveyStep = 1;
    this.currentStep = 1;
    this.firstPage = 2;
    this.router.navigate(['/program']).then(()=>{
      window.scrollTo({top:0,behavior:'smooth'});
    })
  }
  onCountcornAcres(event: any) {

  }

}
function throwError(arg0: () => any): any {
  throw new Error("Function not implemented.");
}


